import React from 'react';

const Wrapper = ({ children }: React.PropsWithChildren) => <div className="wrapper">{children}</div>;

export default Wrapper;
